module.exports = __webpack_public_path__ + "media/images/logo-f09a6ff359d83755f0c54a8be76e3151.svg";